import React from "react";

export function Companies() {
	return <div>Companies page</div>;
}
